import React from 'react';
import { MODO_IMPRESSAO } from '~/constants';

const ComplementaryInfo = ({ info, modoImpressao }) => {
  const impressaoA4 = modoImpressao === MODO_IMPRESSAO.A4;

  return (
    <div className='scrollable' style={{ padding: impressaoA4 ? 'var(--spacing-size)' : 'var(--half-spacing-size) var(--spacing-size)', fontSize: 'var(--regular-text-size)', overflowX: 'auto', ...(!impressaoA4 && { flex: '1 1 0', minWidth: 0 }) }}>
      <div style={{ fontSize: impressaoA4 ? 'var(--section-title-text-size)' : 'var(--regular-text-size)', paddingBottom: 'var(--half-spacing-size)', fontWeight: '700' }}>
        {!impressaoA4 ? 'Info. Complementar' : 'INFO. COMPLEMENTAR'}
      </div>
      <p style={!impressaoA4 ? { whiteSpace: 'pre-line' } : undefined}>{info ? info : 'Sem Informação Complementar.'}</p>
    </div>
  )
};

export default ComplementaryInfo;
